import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { motion } from 'framer-motion';
import { FaArrowLeft } from 'react-icons/fa';

const ProjectDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // Sample projects data. In a real application, fetch this from a backend or context.
  const projects = [
    {
      id: '1',
      title: "E-commerce Platform",
      category: "Web Development",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1200&h=675",
      description: "A full-featured e-commerce platform with seamless checkout and inventory management.",
      gallery: [
        "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=800&h=600",
        "https://images.unsplash.com/photo-1573164574572-cb89e39749a9?auto=format&fit=crop&w=800&h=600",
        // Add more gallery images...
      ]
    },
    {
      id: '2',
      title: "Mobile Banking App",
      category: "UI/UX Design",
      image: "https://images.unsplash.com/photo-1522542550221-31fd19575a2d?auto=format&fit=crop&w=1200&h=675",
      description: "A modern banking application focused on user experience and security.",
      gallery: [
        "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=800&h=600",
        "https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=800&h=600",
        // Add more gallery images...
      ]
    },
    // Add more projects...
  ];

  // Find the project based on the ID from the URL
  const project = projects.find(p => p.id === id);

  if (!project) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-xl">Project not found.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-F5F5DC">
      <Navbar />
      
      {/* Back Button */}
      <motion.div 
        className="container mx-auto max-w-6xl px-4 pt-8"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <button 
          onClick={() => navigate(-1)}
          className="flex items-center text-perspective-green hover:text-perspective-sage transition-colors mb-8"
        >
          <FaArrowLeft className="mr-2" /> Back to Projects
        </button>

        {/* Project Header */}
        <div className="flex flex-col md:flex-row gap-8 mb-12">
          <img 
            src={project.image} 
            alt={project.title} 
            className="w-full md:w-1/2 h-auto rounded-lg object-cover"
          />
          <div className="flex flex-col justify-center">
            <span className="text-perspective-green text-sm font-medium mb-2">{project.category}</span>
            <h1 className="text-4xl font-bold mb-4">{project.title}</h1>
            <p className="text-gray-600">{project.description}</p>
          </div>
        </div>

        {/* Project Gallery */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {project.gallery.map((img, index) => (
            <motion.img 
              key={index}
              src={img}
              alt={`${project.title} Gallery ${index + 1}`} // Fixed the template literal
              className="w-full h-64 rounded-lg object-cover"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            />
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default ProjectDetails;
